document.addEventListener("DOMContentLoaded", function () {
  // SP判定（必要なら幅は変更OK）
  const isSP = window.matchMedia("(max-width: 960px)").matches;

  if (isSP) {
    // 対象クラス一覧
    const targets = [
      { selector: ".box_repair", href: "/products/mask#type_re" },
      { selector: ".box_smooth", href: "/products/mask#type_sm" },
      { selector: ".box_straight", href: "/products/mask#type_st" },

      // { selector: ".product_box_link_whip", href: "/products/whip" },
      // { selector: ".product_box_link_mask", href: "/products/mask" },
    ];

    targets.forEach((item) => {
      const el = document.querySelector(item.selector);
      if (!el) return;

      // aタグを作成
      const link = document.createElement("a");
      link.href = item.href;

      // 元要素を a でラップ
      el.parentNode.insertBefore(link, el);
      link.appendChild(el);
    });
  }
});
